import React from 'react';
import {
    withStyles, Table, TableHead, TableRow, TableCell, TableBody, Typography, Grid,
} from '@material-ui/core';

import AppUtils from '../../control/apputlis';

class MDatePicker extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            myear: this.props.year,
            mmonth: this.props.month,
            datas: this.getDatas(this.props.year, this.props.month)
        }
    }

    getDatas(year, month) {
        let week = this.getWeek(year, month - 1);
        let days = this.getDays(year, month);
        let data = [];
        let months = month < 10 ? '0' + month : month;

        for (let i = 0; i < week; i++) {
            data.push({ day: '', select: false, id: i, date: '', count: 0 });
        }
        for (let i = 0; i < days; i++) {
            let days = (i + 1) < 10 ? '0' + (i + 1) : (i + 1);
            data.push({ day: i + 1, select: false, id: i + week, date: year + '-' + months + '-' + days, count: 0 });
        }
        let datas = AppUtils.processList(data, 7);
        return datas;
    }

    getCount(data) {
        const { MountData } = this.props;
        if (!MountData) return 0;
        for (let i = 0; i < MountData.length; i++) {
            if (MountData[i].date == data.date) {
                return MountData[i].count;
            }
        }
        return 0;
    }

    getMountCount(datas) {
        for (let i = 0; i < datas.length; i++) {
            for (let j = 0; j < datas[i].length; j++) {
                datas[i][j].count = this.getCount(datas[i][j]);
            }
        }
        return datas;
    }

    getWeek = (year, month) => {
        let day = new Date(year, month, 1).getDay();
        return day;
    }

    getDays = (year, month) => {
        let days = new Date(year, month, 0).getDate();
        return days;
    }

    _onClickCell = (datas, day) => {
        for (let i = 0; i < datas.length; i++) {
            for (let j = 0; j < datas[i].length; j++) {
                if (datas[i][j].id == day.id) {
                    datas[i][j].select = true;
                } else {
                    datas[i][j].select = false;
                }
            }
        }
        this.setState({ datas: datas });
        this.props.onChange && this.props.onChange(day);
    }

    render() {
        let { classes, year, month } = this.props;
        let { myear, mmonth, datas } = this.state;
        if (myear != year || month != mmonth) {
            datas = this.getDatas(year, month);
            this.state.myear = year;
            this.state.mmonth = month;
            this.state.datas = datas;
        }

        datas = this.getMountCount(datas);

        console.log(datas);

        return (
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell align='center' className={classes.header}>日</TableCell>
                        <TableCell align='center' className={classes.header}>一</TableCell>
                        <TableCell align='center' className={classes.header}>二</TableCell>
                        <TableCell align='center' className={classes.header}>三</TableCell>
                        <TableCell align='center' className={classes.header}>四</TableCell>
                        <TableCell align='center' className={classes.header}>五</TableCell>
                        <TableCell align='center' className={classes.header}>六</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        datas.map((item, i) => (
                            <TableRow key={i}>
                                {
                                    item.map((v, j) => (
                                        <TableCell align='center' key={j} className={classes.tableCell} onClick={() => this._onClickCell(datas, v)}>
                                            {
                                                v.day != '' && <Grid container direction='column' alignItems='center'>
                                                    <Typography style={{ fontSize: 16, color: v.select ? '#FC182B' : '#0D0D0D' }}>{v.day}</Typography>
                                                    <Typography style={{ fontSize: 10, color: v.select ? '#FC182B' : '#878787', marginTop: 4 }}>{v.count + '场'}</Typography>
                                                    <Grid style={{ backgroundColor: v.select ? '#FC182B' : '#D9E1E7', width: 5, height: 5, marginTop: 4, borderRadius: 2.5 }}></Grid>
                                                </Grid>
                                            }
                                        </TableCell>
                                    ))
                                }
                            </TableRow>
                        ))
                    }
                </TableBody>
            </Table>
        );
    }
}

export default withStyles((theme) => ({
    header: {
        fontSize: 9,
        color: '#0D0D0D',
        margin: theme.spacing(0, 0, 0, 0),
        padding: theme.spacing(1, 0, 1, 0),
        width: '14vw'
    },
    tableCell: {
        margin: theme.spacing(0, 0, 0, 0),
        padding: theme.spacing(1, 0, 1, 0),
        borderBottom: 'solid 1px #E2E2E2',
        width: '14vw'
    },
    arrowIcon: {
        fontSize: 20,
        color: '#000',
        marginLeft: 10,
        marginTop: 10,
    }
}))(MDatePicker);